import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { GlobalDataService } from '../../../services/global-data.service';

@Injectable()
export class PermissionService {

  constructor(
              private http: HttpClient, 
              private global: GlobalDataService
             ) { }


   getPermission(isActive:number=-1) {

        let isAvailable: string ="&active="+isActive;

        if(isActive==-1){
            isAvailable="";
        }

        return this.http.get(this.global.httpUrl+"permissions"+isAvailable);
    }

   getPermissionById(id: any) {
        return this.http.get(this.global.httpUrl+"permissions/"+id);
    } 

   createPermission(data: any){
        return this.http.post(this.global.httpUrl+"permissions", data);
    }

   updatePermission(data: any,id: any){
        return this.http.put(this.global.httpUrl+"permissions/"+id, data);
    } 

}


// WEBPACK FOOTER //
// C:/Users/User/Documents/Projects/Ekopen/angular2-store-test/src/app/dashboard/pages/permissions/permission.service.ts